// extracted by css-extract-rspack-plugin
export default {"cls1":"RemovedItemNotice-cls1_4yt","cls2":"RemovedItemNotice-cls2_fsh RemovedItemNotice-cls1_4yt"};